import { Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { Button } from 'components/shared/Button'
import { NoImageDiv } from 'components/shared/NoImageDiv'
import colors from 'helpers/colors'
import { urls } from 'helpers/urls'
import { generateDateTerm } from 'libs'
import { first } from 'lodash'
import Image from 'next/future/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

export const EventContent: FC<{ eventForDisplay: EventCardType }> = ({
  eventForDisplay,
}) => {
  const {
    // @ts-ignore
    name: placeName,
    // @ts-ignore
    city,
    // @ts-ignore
    state,
  } = first(eventForDisplay?.event_places) || {}
  const { xs } = useBreakpoint()
  const router = useRouter()
  const { t } = useTranslation()
  const { owner } = eventForDisplay

  const imageHeight = xs ? 268 : 434

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: xs ? 'column-reverse' : 'row',
        gap: 24,
      }}
    >
      <div
        style={{
          width: xs ? '100%' : '50%',
          height: xs ? 285 : 434,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: colors.white,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            height: xs ? 'auto' : 200,
          }}
        >
          <Typography.Title
            ellipsis={{ rows: xs ? 2 : 3 }}
            style={{
              fontSize: xs ? 18 : 20,
              lineHeight: 1.5,
              letterSpacing: xs ? 0 : 0.8,
              fontWeight: xs ? 'normal' : 500,
            }}
          >
            {eventForDisplay.title}
          </Typography.Title>
          <Typography.Text
            style={{
              fontSize: 16,
              lineHeight: 1,
              color: 'var(--ax-gray-5, #656565)',
            }}
          >
            {generateDateTerm({
              start: eventForDisplay.start_at,
              end: eventForDisplay.end_at,
              connectingText: '-',
              format: 'YYYY年M月D日',
              formatExceptYear: 'M月D日',
            })}
          </Typography.Text>
          {placeName && (
            <Typography.Text
              style={{
                fontSize: 16,
                lineHeight: 1,
                color: 'var(--ax-gray-5, #656565)',
              }}
            >
              {city}, {state}
            </Typography.Text>
          )}
          <Typography.Text style={{ fontSize: 16, lineHeight: 1.5 }}>
            {t('主催')} :{' '}
            <Link href={urls.owner(owner.id)}>
              <a style={{ textDecoration: 'underline' }}>{owner.name}</a>
            </Link>
          </Typography.Text>
          <Typography.Paragraph
            ellipsis={{ rows: 2 }}
            style={{
              paddingTop: 8,
              fontSize: 16,
              lineHeight: 1,
              fontWeight: 400,
            }}
          >
            {eventForDisplay.description_teaser}
          </Typography.Paragraph>
        </div>
        <Button
          type="primary"
          style={{
            marginTop: xs ? 24 : 40,
            marginBottom: xs ? 24 : 0,
            maxWidth: xs ? '100%' : '320px',
            height: 48,
            fontWeight: 700,
          }}
          onClick={() => router.push(urls.event(eventForDisplay.id))}
        >
          {t('詳細を見る')}
        </Button>
      </div>

      <div style={{ width: xs ? '100%' : '50%', height: imageHeight }}>
        {eventForDisplay.main_event_image_url ? (
          <Image
            src={eventForDisplay.main_event_image_url}
            sizes="100vw"
            style={{ width: '100%', height: imageHeight, objectFit: 'cover' }}
          />
        ) : (
          <div style={{ width: '100%', height: imageHeight }}>
            <NoImageDiv type="event" />
          </div>
        )}
      </div>
    </div>
  )
}
